import * as AuditLogAction from "../actions/audit-log.action";

import { IAuditLogFilterParams } from "@app/audit-log/models/audit-log-type.model";

import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";

@Injectable({
    providedIn: "root",
})
export class AuditLogDispatcher {
    getTypes() {
        this.store.dispatch(AuditLogAction.loadType(null));
    }

    getAuditLogs(params: IAuditLogFilterParams) {
        this.store.dispatch(AuditLogAction.loadAuditLogSet.request({ params }));
    }

    clearAuditLogState() {
        this.store.dispatch(AuditLogAction.clearAuditState());
    }

    clearLogDataState() {
        this.store.dispatch(AuditLogAction.clearAuditDataState());
    }

    constructor(private readonly store: Store) {}
}
